import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const SvgInteractive = lazy(() =>
  import(/* webpackChunkName: "SvgInteractive" */ './SvgInteractive')
);

const Loader = props => (
  <Suspense fallback={null}>
    <SvgInteractive {...props} />
  </Suspense>
);

export default clientOnly(Loader);
